// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { brandCarouselHomePageStyles } from "@sc/App/Widgets/Basic/BrandCarouselHomePage";
import { css } from "styled-components";

brandCarouselHomePageStyles.container = {
    css: css`
        width: 110px;
        min-height: 60px;
    `,
};

brandCarouselHomePageStyles.img = {
    css: css`
        width: auto;
        height: 100%;
        img {
            max-width: 100% !important;
            max-height: 100% !important;
            height: auto !important;
            width: 100% !important;
            min-width: 110px;
        }
    `,
};

brandCarouselHomePageStyles.carouselExtendedStyles = {
    container: {
        css: css`
            .swiper {
                padding-bottom: 25px;
            }
            .swiper-wrapper {
                ${({ autoPlay }: any) => {
                    if (autoPlay) {
                        return css`
                            transition-timing-function: linear;
                            align-items: center;
                        `;
                    }
                }}
            }
        `,
    },
};
